const CATEGORIES = [
  "latest",
  "announcements",
  "quizzes",
  "interviews",
  "guides",
  "seasonal-lineup",
  "deep-dives",
  "features",
];

const SPECIAL_CATEGORIES = [
  "games",
  "merch",
  "manga",
  "anime-awards",
  "crunchyroll-expo",
  "music",
  "movies",
];

const BASENAME = "news";

const HOME_ROUTE_PATTERN = "/";
const CATEGORY_PAGE_PATTERN = `/:category`;
const ARTICLE_ROUTE_PATTERN = `/:category/:year/:month/:day/:slug`;
const AUTHOR_ROUTE_PATTERN = `/author/:authorname`;
const TAG_RESULTS_ROUTE_PATTERN = `/tag/:tag`;
const SEARCH_RESULTS_ROUTE_PATTERN = `/search`;
const ABOUT_ROUTE_PATTERN = `/about`;
const NOT_FOUND_ROUTE_PATTERN = "*";

export {
  BASENAME,
  HOME_ROUTE_PATTERN,
  CATEGORY_PAGE_PATTERN,
  ARTICLE_ROUTE_PATTERN,
  AUTHOR_ROUTE_PATTERN,
  TAG_RESULTS_ROUTE_PATTERN,
  SEARCH_RESULTS_ROUTE_PATTERN,
  ABOUT_ROUTE_PATTERN,
  NOT_FOUND_ROUTE_PATTERN,
  CATEGORIES,
  SPECIAL_CATEGORIES,
};
